module.exports = __webpack_public_path__ + "static/media/veg-icon.b9b10595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/veg-icon.svg
// module id = 595
// module chunks = 11